import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "chat-conversation-item-header"
}
const _hoisted_2 = { class: "chat-conversation-content" }

import { watch, computed } from 'vue'
import { EXTERNAL_LINKS } from '@/scripts/app-configs/constants'
import useIframeCommunication, { iFrameOrigins } from '@/composables/useIframeCommunication'
import { triggers } from '@/scripts/global-modals-commands'
import useChatIframe from '@/views/chat/composables/useChatIframe'
import { EVENT_KEYS } from '@/utils/segment/segment-events'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatPopup',
  props: {
    modalOpen: { type: Boolean, default: false },
    payload: { default: () => ({}) },
    memberSidebarOpen: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const accountUuid = computed(() => props.payload.accountUuid)
const unit = computed(() => props.payload.unit)
const chatChannelUrl = computed(() => props.payload.channelId)
const isChatPopupOpened = computed(() => props.modalOpen)

const { updateIframeRoute } = useIframeCommunication(() => {}, {
  segmentProperties: computed(() => ({
    [EVENT_KEYS.CHAT_CHANNEL_FAILED]: { programUuid: props.payload.programUuid },
    [EVENT_KEYS.INVALID_CHANNELS_ERROR]: { programUuid: props.payload.programUuid },
  })),
  iFrameOrigin: iFrameOrigins.CHAT_POPUP,
  filterOrigin: true,
})
const portalUrl = `${EXTERNAL_LINKS.uiPortal.url}/app/chat?mode=widget`

const iframeEventsHandler = ({ data: { type: eventType, payload } }: { data: { type: string; payload: { [key: string]: string } } }) => {

  // Drop event that come from different tab instances like chat in other tab
  if (eventType !== 'ready' && !isChatPopupOpened.value) return

  switch (eventType) {
    case 'open:summary-patient':
      triggers.toggleMemberSidebar({ memberUuid: payload.patientId })
      break
    case 'close:chat-popup':
      closeChatPopup()
      break
    case 'ready':
      iframeIsReady.value = true
      break
    default:
      break
  }
}

const {
  iframeRef,
  iframeIsReady,
  preferredChannelUrl,
  resetSelectedChatChannelUrl,
} = useChatIframe({ accountUuid, unit, chatChannelUrl }, iframeEventsHandler, { enableIframeUrlUpdate: isChatPopupOpened })

const closeChatPopup = () => {
  resetSelectedChatChannelUrl()
  triggers.closeChatPopup()
}

watch(preferredChannelUrl, (newUrl) => {
  const path = newUrl.replace(/^https?:\/\/[^/]+/, '')

  updateIframeRoute(iframeRef.value! as HTMLIFrameElement, path)
})

return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!

  return (_openBlock(), _createElementBlock("div", {
    id: "chat-popup",
    class: _normalizeClass({ 'summary-sidebar-open': __props.memberSidebarOpen })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['chat-conversation-item', { opened: isChatPopupOpened.value }])
    }, [
      (isChatPopupOpened.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_sword_button_wuk, {
              class: "chat-conversation-item-header__close-button",
              theme: "link",
              round: "",
              size: "small",
              icon: "close",
              onClickNative: closeChatPopup
            })
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("iframe", {
          ref_key: "iframeRef",
          ref: iframeRef,
          src: portalUrl,
          frameborder: "0"
        }, null, 512)
      ], 512), [
        [_vShow, isChatPopupOpened.value]
      ])
    ], 2)
  ], 2))
}
}

})